import React, { FC } from 'react';
import { TypographyProps } from '@material-ui/core/Typography';
import { PropTypes } from '@material-ui/core';
import clsx from 'clsx';
import LinkRouter from '../../../../../common/components/presentation/linkRouter/LinkRouter';
import { ROUTES } from '../../../../../common/constants/routes';
import Translation from '../../../../../gqlCommon/components/translation/Translation';
import changeModelStyles from './changeModelStyles';
import customise from '../../../../constants/customise';

export interface IChangeModelProps {
  align: PropTypes.Alignment;
  variant: TypographyProps['variant'];
  isComplexModel?: boolean;
  sectionName?: string;
}

const ChangeModel: FC<IChangeModelProps> = ({ align, variant, isComplexModel, sectionName }) => {
  const translationId = isComplexModel
    ? 'trans__configurator__customise_page_banner__change_model_link'
    : 'trans__configurator__customise_page_variant_section__change_model_link';
  const styles = changeModelStyles();

  return (
    <LinkRouter
      align={align}
      display={'block'}
      color={'secondary'}
      underline={'always'}
      variant={variant}
      to={ROUTES.MODELS}
      data-test={'link:change_model'}
      className={clsx([styles.changeModelLink], {
        [styles.variantSectionChangeModelLink]: sectionName === customise.VARIANT_ITEM.name,
      })}
    >
      <Translation id={translationId} />
    </LinkRouter>
  );
};

export default ChangeModel;
